import { observer } from "mobx-react-lite";
import { Colors } from "../../../utils/colors";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";
import { ComparisonProgress } from "./ComparisonProgress";
import { ComparisonOverlayLines } from "./ComparisonOverlayLines";
import { useMatchDetailsStore } from "../../../stores/StoreContext";
import { DownloadUltraAppOverlay } from "../../ultraPromo/components/DownloadUltraAppOverlay";

export const PartnerComparison = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div style={{ position: "relative" }}>
      <PartnerAvatarView />
      <ComparisonOverlayLines top={20} bottom={10} />
      <ComparisonProgress />
      {matchDetailsStore.isPromoMode ? <DownloadUltraAppOverlay /> : null}
    </div>
  );
});

const PartnerAvatarView = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();

  return (
    <div
      style={{
        marginTop: 30,
        display: "flex",
        flexDirection: "row",
        marginLeft: 10,
        marginRight: 10,
        position: "relative",
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          justifyContent: "center",
        }}>
        <UserAvatar
          size={50}
          avatar={{
            image:
              matchDetailsStore.currentPartnerComparisonPlayers[0]
                ?.userImageUrl ?? "",
            name:
              matchDetailsStore.currentPartnerComparisonPlayers[0]?.name ?? "",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          justifyContent: "center",
        }}>
        <UserAvatar
          size={50}
          avatar={{
            image:
              matchDetailsStore.currentPartnerComparisonPlayers[1]
                ?.userImageUrl ?? "",
            name:
              matchDetailsStore.currentPartnerComparisonPlayers[1]?.name ?? "",
          }}
        />
      </div>

      <div
        style={{
          position: "absolute",
          width: 1,
          backgroundColor: Colors.success,
          opacity: 0.3,
          top: 40,
          bottom: 10,
          left: 8,
        }}
      />
      {matchDetailsStore.partnerComparisonCurrentPage === 1 && (
        <button
          style={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            border: "none",
            borderRadius: "50%",
            width: 32,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 10,
          }}
          onClick={() => {
            matchDetailsStore.setPartnerComparisonCurrentPage(0);
          }}
          aria-label="Previous">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M13 5L8 10L13 15"
              stroke={Colors.white}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
      {matchDetailsStore.partnerComparisonCurrentPage === 0 && (
        <button
          style={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            border: "none",
            borderRadius: "50%",
            width: 32,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 10,
          }}
          onClick={() => {
            matchDetailsStore.setPartnerComparisonCurrentPage(1);
          }}
          aria-label="Next">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M7 5L12 10L7 15"
              stroke={Colors.white}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
});
